import { render } from "./8th_question.vue?vue&type=template&id=3a47ed82&scoped=true"
import script from "./8th_question.vue?vue&type=script&lang=js"
export * from "./8th_question.vue?vue&type=script&lang=js"

import "./8th_question.vue?vue&type=style&index=0&id=3a47ed82&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a47ed82"]])

export default __exports__